// extracted by mini-css-extract-plugin
export default {"card":"DashCard_card__bRsD8","cardLg":"DashCard_cardLg__mwDod","title":"DashCard_title__Z7rL5","content":"DashCard_content__Omm6S"};